// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"f90b77c2bbfa12c1efd7","453":"1d9f9c0ffcc490ee3d49"}[chunkId] + ".js";
};